<template>
  <div v-if="bodyStyles && bodyStyles.length" class="body_styles">
    <div v-for="(item, index) in bodyStyles" :key="index" class="">
      <div class="body_style_card   text-center cursor_pointer  p-3 align-items-center"
        :style="[index === isChecked ? { border: '1px solid' + primaryColor } : { border: '0px' }, { background: isGradient ? transparentColor : '#fff' }]"
        :class="[{ disabledContent: !isLastIndex }, { custom_box_shadow: !isGradient }]"
        @click.once="eachBodyStyle(item, index)">
        <div class="text-center">
          <!-- <i v-if="index === isChecked" class="primaryicon-tick-icon" :style="{ color: primaryColor }" /> -->
          <!-- <i class="primaryicon-car-empty-body" /> -->
          <!-- <img :src="'../Icons/' + item.iconName + '.svg'" alt="" class="img-fluid" /> -->
          <component :is="item.iconName" :theme-color="textColor" />
        </div>
        <div class="col-12 mt-2">
          <p class="mb-0 _theme_font_bold" :style="[{ color: isGradient ? textColor : '#000' }]">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
import Convertible from '../Icons/Convertible.vue';
import Coupe from '../Icons/Coupe.vue';
import Electric from '../Icons/Electric.vue';
import Hatchback from '../Icons/Hatchback.vue';
import Hybrid from '../Icons/Hybrid.vue';
import MPV from '../Icons/MPV.vue';
import Other from '../Icons/Other.vue';
import Sedan from '../Icons/Sedan.vue';
import SUV from '../Icons/SUV.vue';
import Truck from '../Icons/Truck.vue';
import Van from '../Icons/Van.vue';
import Wagon from '../Icons/Wagon.vue';

// import { ChatWidgetService } from '../../Services/ChatWidgetService/ChatWidgetService';
// import { mapState } from 'vuex';
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings'],
  data() {
    return {
      bodyStyles: [],
      primaryColor: window.primaryColor,
      isChecked: null,
      transparentColor: '',
      textColor: '#B3B3B3',
    }
  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },
  mounted() {

    if (this.botResponse?.component?.values?.length) {
      this.bodyStyles = this.botResponse?.component?.values;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }
    if (this.isGradient) {
      this.transparentColor = 'rgba(0, 0, 0, 0.1)';
      this.textColor = '#fff';
      this.primaryColor = '#fff'
    }
  },
  methods: {
    eachBodyStyle(item, index) {
      // let specialObject = { TvmComponentRequest: item.name };
      ChatWidgetService.postTvmMessage(item.name, null, this.botResponse?.component?.submitFlow,
        this.botResponse?.component?.submitAction);
      this.isChecked = index;
    }
  },
  components: {
    Convertible,
    Coupe,
    Electric,
    Hatchback,
    Hybrid,
    MPV,
    Other,
    Sedan,
    SUV,
    Truck,
    Van,
    Wagon
  }
}
</script>
<style lang="less" scoped>
.body_styles {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.body_style_card {
  border-radius: 10px;

  i {
    font-size: 30px;
  }

  &.disabledContent {
    pointer-events: none !important;
    opacity: 0.9 !important;
  }

  .cursor_pointer {
    cursor: pointer;
  }

}
</style>
